import {useMediaQuery} from '@mui/material'
import {MIN_WIDTH_PAGE_CONTAINER, MID_WIDTH_PAGE_CONTAINER} from 'appearance/styles'

const useResponsive = () => {
    const smallScreen = useMediaQuery(`(max-width:${MIN_WIDTH_PAGE_CONTAINER}px)`)
    const mediumScreen = useMediaQuery(`(max-width:${MID_WIDTH_PAGE_CONTAINER}px)`)
    const largeScreen = useMediaQuery(`(min-width:${MID_WIDTH_PAGE_CONTAINER}px)`)

    return {smallScreen, mediumScreen, largeScreen}
}

export default useResponsive
